export default __webpack_public_path__ + "static/media/noa-19.c19f844e.jpg";